import type { CSSProperties } from "react";

import dayjs from "dayjs";
import { Button as RACButton } from "react-aria-components";
import { twMerge } from "tailwind-merge";

import type { ScheduledPost } from "./scheduledPost";

import { BrandAvatar } from "../BrandFilter";

export function CalendarEvent({
  className,
  isSelected,
  onPress,
  post,
  style,
}: {
  className?: string;
  isSelected?: boolean;
  onPress: () => void;
  post: ScheduledPost;
  style?: CSSProperties;
}) {
  const time = dayjs(post.scheduledAt).format("hh:mm A");
  const isPast = dayjs(post.scheduledAt).isBefore(dayjs());

  return (
    <RACButton
      aria-pressed={isSelected}
      className={twMerge(
        "flex min-w-0 cursor-pointer items-center gap-xs rounded-sm border px-xs py-xxs text-left text-xs font-medium outline-hidden focus-visible:ring-2 focus-visible:ring-border-brand",
        isPast
          ? "border-button-secondary-color-border bg-button-secondary-color-bg text-button-secondary-color-fg"
          : "border-button-primary-bg bg-button-primary-bg text-button-primary-fg",
        isSelected && "ring-2 ring-border-brand ring-offset-1",
        className,
      )}
      onPress={onPress}
      style={style}
    >
      <BrandAvatar
        className="size-3.5 outline-none"
        name={post.brand.name}
        profilePicture={post.brand.profilePicture}
      />
      <span className="min-w-0 flex-1 truncate">{post.title}</span>
      <span className="shrink-0">{time}</span>
    </RACButton>
  );
}
